<template>
  <div>
    <loading
      :active.sync="loading"
      :is-full-page="fullpage"
      :height="26"
      :width="26"
    ></loading>
    <div class="container">
      <!-- <input class="input" v-model="code" placeholder="输入1.0课件码" />
      <p class="errorText" v-if="errorMessage">{{ errorMessage }}</p>
      <button class="button" @click="onFetch">请求1.0课件</button> -->
      <button class="button myButton" @click="onMyCourseware">我的课件</button>
      <button class="button myButton" @click="onLogout">退出登录</button>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import CryptoJS from 'crypto-js';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Privacy',
  components: {
    Loading,
  },
  data() {
    return {
      fullpage: true,
      loading: false,
      code: undefined,
      errorMessage: undefined,
    };
  },

  mounted() {
    const userInfoString = localStorage.getItem('bethel_userinfo');
    const dateString = localStorage.getItem('bethel_login_date');
    if (
      !userInfoString ||
      !dateString ||
      userInfoString.length === 0 ||
      dateString.length === 0
    ) {
      this.$router.replace('/login');
    } else {
      const now = new Date().getTime();
      const date = Number(dateString);
      if ((now - date) / (60 * 60 * 24 * 1000) > 3) {
        this.$router.replace('/login');
      }
    }
  },
  methods: {
    onFetch() {
      this.$router.push({
        path: '/files',
        query: {
          code: CryptoJS.AES.encrypt(
            this.code,
            'bethel_mobile_web_key'
          ).toString(),
        },
      });
    },

    onMyCourseware() {
      this.$router.push('/courseware');
    },

    onLogout() {
      localStorage.setItem('bethel_userinfo', '');
      localStorage.setItem('bethel_login_date', '');
      this.$router.replace('/login');
    },
  },
};
</script>

<style scoped>
li {
  padding: 10px 0px;
  text-align: left;
}

.container {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.input {
  height: 40px;
  width: 300px;
  border-radius: 20px;
  outline: none;
  border: #d5d5d5 1px solid;
  padding: 0 10px;
  margin-bottom: 10px;
}

.button {
  height: 40px;
  width: 320px;
  border-radius: 20px;
  outline: none;
  border: #d5d5d5 1px solid;
  margin-top: 20px;
  background-color: #49afad;
  color: white;
  font-size: 14px;
}
.myButton {
  margin-top: 60px;
}

.input:focus {
  outline: none !important;
}

.errorText {
  color: red;
}
</style>
